import { useEffect, useState } from 'react';
import { useGetLeaderboardQuery } from '../../store/api/api';
import { DirectAuthor } from '../pieces/DirectAuthor';
import DirectAvatar from '../pieces/DirectAvatar';
import { ProgressBar } from '../pieces/ProgressBar';

export function Leaderboard() {
  const {
    data: leaderboard,
    isLoading,
    isError,
    error,
  } = useGetLeaderboardQuery();

  const [maxScore, setMaxScore] = useState(100);

  useEffect(() => {
    if (leaderboard)
      setMaxScore(Math.max(...leaderboard.map((item) => item.score)));
  }, [leaderboard]);

  return (
    <div>
      {isLoading ? <div>Loading...</div> : ''}

      {leaderboard ? (
        <div className="@container">
          <h4 className="my-2 text-lg @lg:text-xl">Leaderboard</h4>
          {leaderboard.map((item) => (
            <div
              key={item.user.id}
              className="my-2 flex w-full flex-row items-center justify-center gap-2 px-2 @md:px-4 @lg:my-4 @lg:gap-4"
            >
              <dt className="flex max-w-[40px] flex-col items-center justify-center">
                <div className="h-9 w-9 overflow-hidden rounded-full object-cover @lg:h-12 @lg:w-12">
                  <DirectAvatar
                    source={item.user.avatar}
                    altcap={item.user.name}
                  />
                </div>
              </dt>
              <dd className="flex w-full grow flex-col items-center justify-center gap-1">
                <div className="flex w-full items-baseline justify-between overflow-hidden text-left text-xs @lg:text-sm">
                  <div>
                    <DirectAuthor id={item.user.id} name={item.user.name} />
                  </div>
                  <div>{item.score}</div>
                </div>
                <ProgressBar
                  value={item.score}
                  max={maxScore ?? 100}
                  label="Score"
                />
              </dd>
            </div>
          ))}
        </div>
      ) : (
        ''
      )}

      {isError ? <div>{error.message}</div> : ''}
    </div>
  );
}
